export default {
  cancelOrderMap: {
    0: "Non lo voglio.",
    1: "Prodotto smarrito",
    2: "Ordine duplicato",
    3: "Ricezione fallita",
    4: "Altri motivi",
  },
  "加值": "Valore aggiunto",
  "提领": "Sollevare",
  "银行卡": "Carta bancaria",
  "联系商家": "Contatta il commerciante",
  "电商批发商场": "Mercato all'ingrosso di e-commerce",
  "用户未发表评论": "L'utente non ha commentato",
  "请输入完整的支付密码!" : "Inserisci la password di pagamento completa!",
  "订单": "Ordine",
  "备注": "Nota",
  "获取验证码": "Ottieni il codice di verifica",
  "请输入验证码": "Inserisci il codice di verifica",
  "验证码": "Codice di verifica",
  "发送": "Invia",
  "已发送，请注意查收": "Inviato, si prega di tenere conto",
  "当前余额": "Saldo attuale",
  "平台人工发起退款": "Il rimborso è stato avviato manualmente dalla piattaforma",
  "下单成功，等待付款": "Ordine effettuato con successo, in attesa di pagamento",
  "下单成功，付款成功": "Ordine effettuato con successo, pagamento andato a buon fine",
  "已发货，正在运输中": "Spedito, in trasporto",
  "订单已取消，原因:手动发起取消订单": "L'ordine è stato annullato. Motivo: annulla l'ordine manualmente.",
  "订单已取消，原因:超时自动取消订单": "L'ordine è stato annullato. Motivo: l'ordine verrà annullato automaticamente al timeout.",
  "商家已确认，已进入备货状态": "Il commerciante è stato confermato ed è entrato nello stato stock.",
  "系统发货成功": "Consegna del sistema riuscita",
  "订单已签收": "Ordine Ricevuto",
  "发起退款申请": "Avviare una richiesta di rimborso",
  "退款成功": "Rimborso riuscito",
  "退款失败": "Rimborso non riuscito",
  "订单退款成功": "Rimborso dell'ordine riuscito",
  "订单退款失败": "Rimborso dell'ordine non riuscito",
  "系统默认好评": "Il sistema imposta automaticamente le recensioni favorevoli",
  "请输入关键字搜索": "Inserisci la parola chiave per la ricerca",
  "猜你喜欢": "Immagino che ti piaccia",
  "订单已完成": "L'ordine è completato",
  "热销推荐": "Raccomandazione di vendita calda",
  "头像选择": "Selezione dell'avatar",
  "修改头像": "Modifica il tuo avatar",
  subOrder: "Inviare ordine",

  "mailboxCheck": "Si prega di inserire l'indirizzo e-mail corretto",
  "switchLang": "Passa a un'altra lingua per visualizzare",
  "myCart": "Il mio carrello",
  "notQua": "Le condizioni di qualificazione non sono soddisfatte.",
  "noSmaller": "L'importo applicato non può essere inferiore a",
  "nomax": "L'importo massimo della domanda non può superare",
  "evaluationUploading": "Hai ancora il caricamento delle immagini. Per favore riprova più tardi",
  "evaluateInput": "Recensione con immagini",
  "moneyOrderStatus": "Lo stato dell'ordine",
  "coinBlock": "Accordo valutario",
  "dealing": "In corso",
  "dealSuccess": "Riuscito",
  "dealFail": "Fallire",
  "payCertificate": "Certificato di pagamento",
  "handleFee": "Costo del servizio",
  "highOpinion": "Buone recensioni",
  "mediumOpinion": "Recensione media",
  "lowOpinion": "Recensioni negative",
  "hasImage": "Con immagini",
  "rechargeMethod": "Modalità di ricarica",
  "scanAndDown": "Scansiona il codice QR Scarica l'APP",
  "receivedAddress": "Indirizzo di ricezione",
  "ActualLedger": "Scontrino vero e proprio",
  "view": "Visualizzazione",
  "withdrawNum": "Quantità di prelievo di contanti",
  "rechargeNum": "Quantità di ricarica",
  "date": "Data",
  "walletHistory": "Storia del portafoglio",
  "accountBalance": "Saldo del conto",
  "accountReview": "Panoramica dell'Account",
  "rated": "Rivisto",
  "receiver": "Ricevitore",
  "orderStatus": "Stato",
  "orderTime": "Tempo",
  "tax": "Tassazione",
  "discount": "Sconto",
  "productInfo": "Informazioni sul prodotto",
  "paramError": "Errore di parametro",
  "orderInfo": "Informazioni sull'ordine",
  "rebuy": "Un altro ordine",
  "pleaseCorrectAddress": "Inserisci l'indirizzo corretto per il prelievo di contanti",
  "pleaseInputCorrectNumber": "Inserisci un numero maggiore di 0",
  "vcodePass": "Verifica superata!",
  "vcodeFail": "Autenticazione fallita. Per favore riprovare",
  "uploading": "Caricamento...",
  "uploadSuccess": "Caricamento riuscito",
  "uploadError": "Caricamento fallito. Per favore riprova",
  "registerSuccess": "Registrazione riuscita",
  "pleaseSetMobileNumber": "Si prega di impostare il numero di telefono",
  "unSelectedProduct": "Non hai selezionato un prodotto",
  "loginSuccess": "Accesso riuscito",
  "pleaseSetAreaCode": "Inserisci il nome del paese e il prefisso per la ricerca",
  "login": "Login",
  "register": "Registrazione",
  "logout": "Uscita",
  "noData": "Nessun dato trovato",
  "search": "Ricerca",
  "historySearch": "Ricerca storica",
  "empty": "Vuoto",
  "home": "Pagina iniziale",
  "favorableRate": "Tasso di buone recensioni",
  "classification": "Categoria",
  "searchTips": "Ricerca fonte/prodotto/fornitore/ordine",
  "dailyNewArrival": "Quotidiano nuovi prodotti elencati",
  "more": "Di più",
  "recommend": "Raccomandazione",
  "recommendedProducts": "Prodotti consigliati",
  "recommendedStore": "Negozi consigliati",
  "buyNow": "Acquista adesso",
  "addCart": "Aggiungere al carrello della spesa",
  "complex": "Integrato",
  "price": "Prezzo",
  "retailPrice": "Prezzo al dettaglio",
  "originPrice": "Prezzo originale",
  "service": "Assistenza clienti",
  "collect": "Preferiti",
  "sold": "Volume delle vendite",
  "pageviews": "Quantità di navigazione",
  "quantity": "Quantità",
  "freight": "Carico",
  "shipping": "Spedizione",
  "ship": "Barca",
  "buyTips": "Spedizione entro 24 ore dall'ordine. I seguenti ordini sono sotto controllo logistico e potrebbero essere spediti in ritardo. Si prega di prestare attenzione alle informazioni logistiche o contattare il servizio clienti.",
  "totalPrice": "Prezzo totale",
  "addCartMessage": "Aggiunto con successo al carrello",
  "addCartMessageFaild": "Il prodotto esiste già nel carrello.",
  "myAccount": "Il mio conto",
  "buyHistory": "Record di acquisto",
  "wishlist": "Prodotti preferiti",
  "trackOrder": "Ordine",
  "account": "Account:",
  "sellerZone": "Zona mercantile",
  "beSeller": "Diventa un commerciante",
  "sellerPanelLogin": "Accesso commerciante",
  "footTip": "© Copyright {name} Ltd 2024",
  "footTips": "{name} Limited è autorizzata e regolamentata dalla Financial Conduct Authority come mediatore creditizio (713206) e tratta esclusivamente con l'istituto di credito Home Retail Group CardServices Limited come {name} Financial Services. {name} Financial Services è autorizzata e regolamentata dalla Financial Conduct Authority a fornire credito (716148). Home Retail GroupCard Services Limited è registrata nel Regno Unito (04007072) ad Avebury, 489-499 Avebury Boulevard, Milton Keynes, Regno Unito. MK9 2NW.",
  "item": "Articolo",
  "checkout": "Effettua un ordine",
  "productDescription": "Descrizione del prodotto",
  "userEvaluation": "Recensioni degli utenti",
  "AllProducts": "Tutti i prodotti",
  "followers": "Seguire",
  "sales": "Volume delle vendite",
  "visitStore": "Visita il negozio",
  "authentic": "100% genuino",
  "dayReturns7": "7 giorni di ritorno",
  "shippingDiscounts": "Sconto sul trasporto",
  "safePayment": "Pagamento sicuro",
  "followed": "Seguito",
  "dashboard": "Pannello degli strumenti",
  "myOrder": "Il mio ordine",
  "setUp": "Impostare",
  "successTips": "Riuscito",
  "copySuccess": "Replica riuscita",
  "balance": "Saldo(USDT)",
  "sort": "Tipo",
  "commodity": "Prodotto",
  "browse": "Volume delle vendite",
  "recharge": "Ricaricare",
  "commodityCollection": "Collezione di prodotti",
  "withdraw": "Ritiro contanti",
  "defaultAddress": "Indirizzo predefinito",
  "addNewAddress": "Aggiungi un nuovo indirizzo",
  "withdrawRecord": "Record di prelievo di contanti",
  "serialNumber": "Numero d'ordine.",
  "time": "Tempo",
  "amount": "Quantità",
  "processing": "In corso",
  "fail": "Fallire",
  "blockchainNetwork": "Rete blockchain",
  "records": "Documentazione",
  "withdrawAddress": "Indirizzo per il prelievo di contanti",
  "withdrawInputTips": "Si prega di inserire l'indirizzo di ritiro",
  "copy": "Replica",
  "enterTips": "Prego entra",
  "actualAccount": "Conto reale",
  "handlingFee": "Costo del servizio",
  "confirm": "Conferma ricezione",
  "previous": "Passo precedente",
  "pleaseEnterAddress": "Inserisci l'indirizzo",
  "pleaseEnterQuantity": "Si prega di inserire la quantità",
  "withdrawSuccess": "Ordini inviati con successo",
  "saveQr": "Salva codice QR",
  "pleaseEnterAmount": "Inserisci l'importo della ricarica",
  "expectedArrival": "Arrivo previsto",
  "currentRate": "Tasso di cambio attuale",
  "uploadTips": "Prova di pagamento (carica la schermata dei dettagli di pagamento)",
  "clickUpload": "Clicca per caricare",
  "uploadPhoto": "Si prega di caricare foto",
  "rechargeSuccessful": "Ricarica riuscita",
  "rechargeTips": "\"Richiesta di ricarica: \"\"Si prega di compilare l'importo effettivo del trasferimento in modo veritiero. In caso contrario, il sistema potrebbe non superare l'approvazione e influire sull'avanzamento della ricarica.\"",
  "rechargeRecord": "Ricarica record",
  "all": "Tutto",
  "pending": "Essere pagato",
  "cancelled": "Annullato",
  "delivered": "Essere spedito",
  "confirmed": "Confermato",
  "receipt": "Da ricevere",
  "harvested": "Ricevuto",
  "comment": "Da rivedere",
  "refund": "Rimborso/post-vendita",
  "cancelOrder": "Annulla Ordine",
  "cancelReason": "Motivo della cancellazione",
  "cancelOrderTitle": "Seleziona un motivo per l'annullamento dell'ordine",
  "returnOrderTitle": "Si prega di selezionare il motivo del reso",
  "refundInstructions": "Istruzioni per il rimborso",
  "returnDetailTips": "Si prega di dare una recensione sul prodotto",
  "cancel": "Annulla Ordine",
  "cancelOrder1": "Prodotto non ricevuto",
  "cancelOrder2": "Non mi piace, non lo voglio",
  "cancelOrder3": "Il venditore ha spedito la merce sbagliata",
  "cancelOrder4": "Marchio falso",
  "cancelOrder5": "Meno spedizione, spedizione mancata",
  "cancelOrder6": "Prodotto ricevuto danneggiato",
  "cancelOrder7": "C'è un problema di qualità",
  "cancelOrder8": "Negoziare il rimborso con il commerciante",
  "cancelOrder9": "Altri motivi",
  "cancelOrderSuccess": "Ordine annullato con successo",
  "returnOrderSuccess": "Invia con successo",
  "orderName": "Nome",
  "orderEmail": "E-mail",
  "orderAddress": "Indirizzo",
  "orderNation": "Paese",
  "orderState": "Stato",
  "orderCity": "Città",
  "orderPostCode": "Codice Postale",
  "orderAmount": "Quantità",
  "orderPrefix": "Ordine totale",
  "orderFee": "Le tasse",
  "orderSpecification": "Specifica",
  "orderCommodity": "Prodotto",
  "orderQuantity": "Quantità",
  "orderUnitprice": "Prezzo unitario",
  "orderFreight": "Carico",
  "orderTax": "Imposta",
  "orderTotal": "Totale",
  "PaymentOrder": "Ordine di pagamento",
  "Evaluate": "Revisione",
  "CancelOrder": "Annulla Ordine",
  "RemindShip": "Ricorda per la spedizione",
  "Refund": "Rimborso",
  "Submitareview": "Invia recensioni",
  "Information": "Informazione",
  "wrongPassword": "Errore password più di 3 volte. Si prega di riprovare domani.",
  "Operate": "Operazione",
  "Item": "Elementi)",
  "From": "Da",
  "hint": "Suggerimenti",
  "CheckDetails": "Visualizza dettagli",
  "Payment": "Pagamento",
  "Cancel": "Annulla",
  "refundSuccessfully": "Rimborso riuscito",
  "pendingPayment": "Essere pagato",
  "pay": "Pagamento",
  "LoginPassword": "Password per il login",
  "sure": "Ovviamente",
  "shippingAddress": "Indirizzo di ricezione",
  "pleaseAddShippingAddress": "Si prega di aggiungere prima un indirizzo di spedizione",
  "transactionPassword": "Parola d'ordine della transazione",
  "markDefaultAddress": "Contrassegna come predefinito Indirizzo di spedizione",
  "edit": "A cura di",
  "delete": "Eliminare",
  "Opt": "Selezionare",
  "piece": "Pz",
  "orderDetails": "Dettagli dell'ordine",
  "shopCollection": "Aggiungi il negozio ai preferiti",
  "addAddress": "Aggiungi un nuovo indirizzo",
  "signUp": "Registrazione",
  "loginTips": "Hai già un account?",
  "loginIn": "Login",
  "mobile": "Telefono n",
  '购物车还没有商品': "Il carrello non ha ancora prodotti",
  '去购物': "Vai a fare shopping",
  "modifyAddress": "Modifica indirizzo",
  "desc": "Imposta come indirizzo predefinito",
  "keep": "Mantenere",
  "onlineService": "Servizi online",
  "send": "Inviare",
  "EsShop": "Negozio online",
  "desc3": "Inserisci la password della transazione",
  "desc4": "Inserisci la password della tua transazione",
  "desc6": "Inserisci nuovamente la password della transazione",
  "setUpPayPaw": "Imposta la password della transazione",
  "setSuccess": "Installazione riuscita",
  "confirmPayPaw": "Conferma la password della transazione",
  "paymentSuccessful": "Pagamento riuscito",
  "paymentPending": "Pagamento in attesa",
  "paymentPendingDesc": "Il tuo pagamento è in fase di elaborazione. Controlla lo stato dell'ordine più tardi",
  "desc5": "Indirizzo di spedizione errato? Contatto",
  "customeService": "Servizio clienti in linea",
  "BackHome": "Torna alla pagina iniziale",
  "Checkorder": "Visualizza l'ordine",
  "ForgotPassword": "Hai dimenticato la password?",
  "signIn": "Login",
  "noAccount": "Nessun numero di conto?",
  "pleaseEnterAccount": "Inserisci il numero di conto",
  "pleaseEnterPassword": "Per favore, inserisci la password",
  "password": "Parola d'ordine",
  "mobilePhone": "Numero di telefono",
  "pleaseEnterPhoneNumer": "Si prega di impostare il numero di telefono",
  "setPassword": "Impostare la password",
  "noDataFound": "Nessun dato trovato",
  "searchCountry": "Inserisci il nome del paese e il prefisso per la ricerca",
  "pleaseEnterEmail": "Si prega di impostare la casella di posta",
  "invitationCode": "Codice invito",
  "plaeseEnterInvitaionCode": "Si prega di impostare il codice di invito",
  "pleaseSetLoginPassword": "Si prega di impostare la password di accesso",
  "selectDeliveryAddress": "Seleziona l'indirizzo di spedizione",
  "totalOf": "Totale",
  "items": "Articolo",
  "orderSummary": "Riepilogo dell'ordine",
  "paymentMethod": "Metodo di pagamento",
  "Balance": "Bilancia",
  "payPal": "PayPal",
  "notOpen": "Questo metodo di pagamento non è ancora disponibile per la tua regione",
  "mastercard": "MasterCard",
  "additional": "Extra",
  "handlingfee": "Tassa di servizio richiesta",
  "goodsNumber": "Quantità di prodotti",
  "deliveryFee": "Trasporto",
  "totalNum": "Totale",
  "new": "Nuovo",
  "oldPassword": "Vecchia password",
  "pleaseEnterOldPassword": "Inserisci la vecchia password",
  "newPassword": "Nuova password",
  "plaseeEnterNewPassword": "Inserisci la nuova password",
  "confirmPassword": "Conferma password",
  "plaseeENterConfirmPassword": "Inserisci la password di conferma",
  "twoPawword": "Due password non sono uguali",
  "rechargeAddress": "Indirizzo di ricarica",
  "plaseEnterRechargeAddress": "Inserisci l'indirizzo di ricarica",
  "userCenter": "Centro personale",
  "merchantSettled": "Ingresso mercantile",
  "upNew": "Nuovo prodotto elencato",
  "balanceNot": "Il saldo non è sufficiente. Si prega di ricaricare.",
  "NoProductSelected": "Prodotto non ancora selezionato",
  "ShippingAddressNotSet": "Indirizzo di spedizione non impostato",
  "consigneeName": "Nome del destinatario",
  "email": "E-mail:",
  "areaCode": "Prefisso internazionale",
  "phoneNumber": "Numero di telefono",
  "nation": "Paese",
  "state": "Provincia/Stato/Stato",
  "city": "Città",
  "postCode": "Codice Postale",
  "address": "Indirizzo dettagliato",
  "addAddressOrModifyAddress": "Aggiungi nuovo indirizzo/Modifica indirizzo",
  "setAsTheDefaultAddress": "Imposta come indirizzo predefinito",
  "proceed": "Continua",
  "btnSure": "Confermare",
  "pleaseInput": "Prego entra",
  "allProduct": "Tutti i prodotti",
  "myCommodityCollection": "Prodotti preferiti",
  "myFollowedShops": "Segui il negozio",
  "mySold": "Venduto",
  "myPageviews": "Quantità di navigazione",
  "myPraiseRate": "Tasso di buone recensioni",
  "myUnfollow": "Smetti di seguire",
  "inputNum": "Numeri",
  "inpuEmailErro": "Inserisci l'indirizzo email corretto",
  "goodsShip": "Spedizione",
  "goodsShipTips": "I prodotti verranno spediti entro 24 ore dall'ordine. Se esiste un controllo logistico per il seguente ordine, l'ordine potrebbe essere ritardato. Si prega di prestare attenzione alle informazioni logistiche dell'ordine o contattare il servizio clienti.",
  "goodsFreight": "Trasporto",
  "goodsFreeShipping": "Gratuito",
  "goodsFreightTips1": "1. Composizione del trasporto transfrontaliero del prodotto: trasporto = tassa di spedizione + trasporto a lunga distanza + tassa di consegna",
  "goodsFreightTips2": "2. Se le condizioni di affrancatura non sono soddisfatte, il trasporto sarà addebitato in base alle condizioni effettive.",
  "goodsFreightTips3": "3. Il diritto di interpretazione finale appartiene alla piattaforma.",
  "pleaseValidPostCode": "Inserisci più di 4 cifre",
  "pleaseValidEmail": "Inserisci l'indirizzo email corretto",
  "pleaseValidPhone": "Inserisci il numero di telefono corretto",
  "productAvailable": "Questo prodotto è stato rimosso",
  "validatorMaxNumber": "L'importo supera il limite",
  "validatorRequire": "Gli elementi obbligatori non possono essere nulli",
  "validatorPhone": "Inserisci il numero di telefono corretto",
  "validatorEmail": "Inserisci il formato email corretto",
  "validatorPassword": "La password è composta da 6-12 cifre o lettere(contiene caratteri speciali)",
  "validatorSixNumber": "Inserisci 6 cifre pure",
  "validatorFourMoreNumber": "Inserisci una combinazione di 4-32 cifre o lettere",
  "validatorIpRule": "Formato IP errato",
  "validatorChineseAndEnglish": "Solo cinese e inglese, inserire l'intervallo: 8-64 caratteri",
  "collectionSuccess": "Aggiungi ai preferiti con successo",
  "followedSuccess": "Segui riuscito",
  "cancelSuccess": "Annullato con successo",
  "evaluateOrder": "Recensione con immagini",
  "evaluateOrderPlaceholder": "Si prega di rivedere i prodotti",
  "operationSuccess": "Operazione riuscita",
  "confirmReceiveGoods": "Confermare o meno la ricezione del prodotto",
  "evaluateOrderSuccess": "Revisione riuscita",
  "yesterday": "Ieri",
  "notLogin": "Non hai ancora effettuato l'accesso.",
  "delAllHistoryRecord": "Sei sicuro di voler eliminare tutti i record della cronologia?",
  "or": "O",
  "tipsRemindsText": "Il commerciante riceverà un promemoria dopo che la spedizione è stata ricordata",
  "tipsRemindsCount": "Può essere ricordato solo una volta.",
  "tipsRemindsMerchant": "Ricorda ai commercianti",
  "tipsRemindsSuccess": "Promemoria riuscito",
  "noCartTips": "Il tuo carrello è vuoto. Inizia a fare acquisti.",
  "defaultRate": "Il sistema imposta automaticamente le recensioni favorevoli",
  "prevPage": "Pagina precedente",
  "nextPage": "Pagina successiva",
  "returnApply": "Richiesta di rimborso",
  "returnReason": "Motivo del rimborso",
  "returnAmount": "Importo del reso",
  "returnRemark": "Istruzioni per la restituzione",
  order: {
    cancel: "Annulla Ordine",
    confirm: "Conferma ricezione",
    payment: "Paga ora",
    remind: "Ricorda per la spedizione",
    return: "Richiesta di rimborso del prodotto",
    evaluate: "Rivedi ora",
    logistics: "Visualizza la logistica",
    noRefund: "Non rimborsato",
    refunding: "Rimborso in corso",
    refundSuccess: "Rimborso riuscito",
    refundFail: "Rimborso non riuscito",
  },
  "remindTitle": "Ricorda per la spedizione",
  "remindContent": "Dopo il sollecito della spedizione, il commerciante riceverà il sollecito. Può essere ricordato solo una volta.",
  "remindSuccess": "Promemoria riuscito",
  "remindRepeat": "Questo ordine è stato ricordato.",
  "noComments": "Nessuna recensione al momento",
  "storeSeach": "Cerca il prodotto in questo negozio",
  "storeSeachTips1": "Trovato per te",
  "storeSeachTips2": "Negozi correlati trovati",
  "storeSeachTips3": "Casa",
  "creditTit": "Servizi di credito",
  "getCoupons": "Ottieni più coupon",
  "yourEmail": "Il tuo indirizzo di posta elettronica",
  "subscription": "Abbonamenti",
  "paymethods": "Metodo di pagamento",
  "footdec": "Gli utenti del sito globale di {name} provengono da {num} paesi in tutto il mondo e utilizzano {coin} per il pagamento. {coin} è una transazione senza confini che consente transazioni immediate ea basso costo in tutto il mondo senza attese e commissioni internazionali.",
  "custService": "Assistenza clienti",
  "helpLine": "Servizio clienti in linea",
  "contactUs": "Contattaci",
  "客户端下载":
    "Scarica il cliente",
  "partner": "Fornitori cooperativi",
  "提现方式": 
    "Modalità di rimborso",
  "buyRules": "Regole dell'acquirente",
  "sellerRules": "Politica del venditore",
  "returnsAndEx": "Resi e cambi",
  "servicePolicy": "Politica di servizio",
  "returnPolicy": "Politica di ritorno",
  "user_Center": "Centro utenti",
  "userReg": "Registrazione Utente",
  "orderTrack": "Domanda d'ordine",
  "purchageHistory": "Cronologia degli acquisti",
  "myPurse": "Il mio portafoglio",
  "aboutUs": "Chi siamo",
  "Recruitment": "Aspetta persone di talento",
  "news": "Informazioni sulle notizie",
  "stateMent": "Dichiarazione di schiavitù moderna",
  "binance": "Binanza",
  "huobi": "Hubi",
  "okx": "okx",
  "metaMask": "MetaMaschera",
  "homeBannertips1": "Diventa un commerciante",
  "homeBannertips2": "Commissione totale",
  "homeBannertips3": "Massimo.",
  "homeBannerbtn": "Iscriviti adesso",
  "homeDownloadtips1": "Centro commerciale all'ingrosso di e-commerce transfrontaliero",
  "homeDownloadtips2": "Offerta speciale di marca",
  "homeDownloadtips3": "Sconto continuo",
  "homeDownloadtips4": "Scarica Android",
  "homeDownloadtips5": "Scarica Apple",
  "homeDownloadtips6": "Scansiona il codice QR per scaricare l'APP",
  "homeIconTips1": "100% genuino",
  "homeIconTips2": "7 giorni di ritorno",
  "homeIconTips3": "Sconto sul trasporto",
  "homeIconTips4": "pagamento sicuro",
  "headerSearchTips": "Inserisci la parola chiave per la ricerca",
  "collAccount": "Modalità di prestito",
  "mine": "Mio.",
  "creditText1": "I prestiti di avvio risolvono il problema del prestito di denaro",
  "creditText2": "Fornire servizi di prestito iniziale e rotazione del capitale",
  "creditWorry": "Prestito senza preoccupazioni",
  "creditQuota": "Limite flessibile",
  "creditQuotaINFO": "Da 100.000 a 30.000.000 con limite flessibile e senza vincoli, con durata massima del prestito di un anno.",
  "quickLoan": "Prestito veloce",
  "creditReview": "Supera l'audit entro un'ora al più presto, se la revisione viene superata, il prestito verrà rilasciato immediatamente.",
  "safe": "Sicuro e senza preoccupazioni",
  "safeInfo": "Nessun mutuo, nessun deposito, nessuna richiamata, perché questa è in realtà una questione privata.",
  "about": "Chi siamo",
  "aboutText1": "\"Ci impegniamo a prestare servizi finanziari, basati sulla filosofia aziendale \"\"primo cliente\"\", con la missione di risolvere il problema della rotazione del capitale del cliente. Fin dalla sua fondazione, l'azienda ha aiutato numerosi clienti a risolvere il problema della rotazione del capitale.\"",
  "aboutText2": "Limite: 100.000-30.000.000, metodo di rimborso flessibile con interessi bassi, nessuna commissione anticipata, prestito online, nessuna telefonata per la verifica, informazioni riservate e prestito in giornata.",
  "contactUs1": "Se non vuoi prendere in prestito denaro dai tuoi compagni di livello, contattaci.",
  "committed": "Impegnato nei servizi di prestito all'imprenditore",
  "financial": "Affronta le tue preoccupazioni finanziarie",
  "partnersTit": "Piattaforma di prestito partner online",
  "application": "Domanda di prestito",
  "applicant": "Richiedente",
  "actualName": "Vero nome",
  "yourName": "Inserisci il nome",
  "term": "Durata del prestito",
  "applicationAmount": "Importo richiesto",
  "rates": "Tasso di interesse del prestito",
  "loanMethod": "Modalità di prestito",
  "accountB": "Saldo del conto",
  "countryOf": "Nazionalità",
  "myloan": "Il mio prestito",
  "applyLoan": "Chiedere un prestito",
  "loaned": "In prestito",
  "interest": "Interessi maturati",
  "esRepayment": "Rimborso stimato",
  "loanHistory": "Record di prestito",
  "applicantDate": "Data di applicazione",
  "repayment": "Rimborso",
  "cycle": "Ciclo di rimborso",
  "fixedRate": "Tasso di interesse fisso",
  "successLoan": "Prestito riuscito",
  "Reapply": "Riapplicare",
  "borrow": "Prestito fallito",
  "applicantIn": "Applicazione in corso",
  "repaid": "Rimborso",
  "overdue": "In ritardo",
  "estirepay": "Rimborso stimato",
  "loanDays": "Numero di giorni prestati",
  "reAmount": "Importo del rimborso",
  "repay": "Modalità di rimborso",
  "entRepay": "Conferma il rimborso",
  "foryourmoney": "Se sei in carenza di fondi, non trovi un posto dove prendere in prestito denaro o sei imbarazzato a prendere in prestito denaro dai tuoi amici, puoi contattarci. Abbiamo l'intero processo di servizio professionale per rispondere ai tuoi dubbi in qualsiasi momento. Il nostro obiettivo è rendere trasparente ogni prestito, in modo che i clienti possano utilizzarlo in modo rapido e sicuro.",
  "onlineApplin": "Applicare online",
  "businessloan": "Domanda di prestito iniziale",
  "selectCountry": "Seleziona una nazionalità",
  "selectPeriod": "Si prega di selezionare un periodo",
  "passPortImg": "ID n./Passaporto n.",
  "uploadId": "Caricamento foto certificato/passaporto",
  "readAndAgree": "Ho letto e sono d'accordo",
  "loanAgree": "Contratto di prestito",
  "submitApplica": "Presentazione della domanda",
  "photoExample": "Esempio di scattare foto",
  "discounted": "Prodotti scontati",
  "days": "giorno",
  "privacyPolicy": "Politica sulla riservatezza",
  "delivery": "Consegna e ritiro",
  "checkAgreement": "Si prega di spuntare l'accordo!",
  "businessPhone": "Telefono aziendale",
  "businessEmail": "Posta elettronica aziendale",
  "充值金额不能小于1": "L'importo della ricarica non può essere inferiore a 1 (compresi i due decimali)",
  "请切换其他语言后查看": "Passa a un'altra lingua per visualizzare",
  "我的购物车": "Il mio carrello",
  "推荐商品": "Prodotti consigliati",
  "猜你喜欢": "Immagino che ti piaccia.",
  "暂无店铺": "Nessun negozio trovato",
  "添加失败": "Impossibile inviare. Per favore riprova più tardi",
  "提交订单": "Invio dell'ordine",
  recommendclass:"Categoria consigliata",
  "滑动验证": "Verifica a scorrimento",
  "最多上传9张图片": "Carica fino a 9 immagini",
  "账号注销": "Disattivazione dell'account",
  "确定注销": "Conferma la disattivazione",
  "您的账号": "Il tuo account",
  "为什么要离开": "Perché lasciare?",
  "App下载(买家端)": "App download (buyer)",
  "App下载(卖家端)": "App download (seller)",
  "您还有余额,不能注销账号": "Hai ancora un saldo, non puoi disattivare l'account!",
  "请输入注销理由": "Inserisci il motivo per cui disattivi l'account",
  "您确认要注销吗?": "Sei sicuro di voler disattivare l'account?",
  "我再考虑下": "Rifletterò ancora",
  "最多包含10位小数": "Può contenere fino a 10 decimali",
  "同意注销": "Accetto la disattivazione",
  "注销成功": "Disattivazione riuscita",
  "请选择": "Si prega di selezionare",
  "绑定成功": "Vincolato con successo",
  "企业电话": "Telefono aziendale",
  "职业机会": "Opportunità di carriera",
  "仅能绑定一个收款地址!": "Puoi solo vincolare un indirizzo di pagamento!",
  "长时间未付款，系统自动取消订单": "Se non paghi per un lungo periodo di tempo, il sistema annullerà automaticamente l'ordine",
  "提款地址绑定": "Indirizzo di prelievo vincolato",
  "加密货币": "Valuta crittografica",
  "银行卡": "Carta bancaria",
  '参数缺失': "Parametro mancante",
  '充值数量必填': "L'importo della ricarica è obbligatorio",
  "充值币种": "Valuta di ricarica",
  "充值金额": "Importo della ricarica",
  "充值金额不得小于": "L'importo della ricarica non può essere inferiore a",
  "充值金额不得大于": "L'importo della ricarica non può essere superiore a",
  "请先选择币种": "Seleziona prima la valuta",
  "开户行": "Banca di deposito",
  "请输入开户行名称": "Inserisci il nome della banca di deposito",
  "银行卡号": "Numero di carta bancaria",
  "请输入银行卡号": "Inserisci il numero di carta bancaria",
  "点击去支付": "Fai clic per pagare",
  "企业证明": "Certificato aziendale",
  footTipTikTok:'Centro commerciale CoveBuy ©️2024 Copyright',
  TikTokFoot:"CoveBuy è una piattaforma sociale globale di video brevi CoveBuy e la più grande società di commercio all'ingrosso dell'Asia Alibaba, fondata in collaborazione. È una piattaforma di e-commerce globale e dispone di tre magazzini intelligenti autogestiti nel mondo, situati a Toronto, in Canada, Los Angeles e Chiba, in Giappone. I prodotti in vendita nell'app includono prodotti popolari provenienti da Giappone, Corea del Sud, Cina e altri paesi asiatici. Al momento, il numero totale ha superato i 50.000 e continua a crescere rapidamente.",
  "cancelInfo":"avvisare! Fai attenzione a cancellare l'account. Se non utilizzi più l'account, puoi fare clic su [Accetta cancellazione]. Potresti non essere in grado di registrarti entro pochi giorni dalla cancellazione.",
  "betaBannerText": "Il sito web è in fase di test pubblico, si prega di non effettuare ordini"
}